/**
 * Logger: em produção não exibe NENHUM log no console (zero vazamento).
 * Em desenvolvimento, log.info / log.warn / log.error funcionam normalmente.
 */
const isDev = process.env.NODE_ENV === 'development';

export const log = {
  info: (...args) => {
    if (isDev) console.log(...args);
  },
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  error: (...args) => {
    if (isDev) console.error(...args);
  }
};
